import { geoCtaTemplate, geoModalPhoneTemplate, geoModalAddressTemplate } from '../templates/geo.js'

class Geo {
    
    constructor() {

        this.parent = document.querySelector(".header__geo");
        if (!this.parent) return false;

        this.geoCta   = this.parent.querySelector(".container");
        this.geoCtaAddress = this.geoCta.querySelector("address");
        this.geoModal = this.parent.querySelector(".contact-tile--overlay");
        this.closeBtn = this.geoModal.querySelector(".button--close");
        this.eleBtnGeolocateMe = document.querySelectorAll('.button__geolocateme');

        const lang = document.documentElement.lang.substr(0,2);

        this.garage = null;
        this.coords = null;
        this.geoPermission = null;
        this.storageKey = "napa_nearest_garage";
        this.defaultHref = this.geoCta.href;
        this.fetchOptions = {
            headers: {
                'Accept-Language': lang
            },
        };

        this.init();
    }

    init() {

        let $this = this;

        this.geoCta.addEventListener("mouseenter", function(){ $this.initOpen($this); });
        this.geoCta.addEventListener("mouseleave", function(){ $this.initClose($this); });
        this.geoModal.addEventListener("mouseenter", function(){ $this.initOpen($this); });
        this.geoModal.addEventListener("mouseleave", function(){ $this.initClose($this); });
        this.closeBtn.addEventListener("click", function(){ $this.initClose($this, true); });

        this.initTriggers();
        this.initNearest();
    }

    initOpen( $this ) {
        if (!$this.parent.classList.contains("active")) return;

        $this.geoModal.setAttribute('data-active', true);

        if (!$this.geoModal.classList.contains("on")) {
            $this.geoModal.style.display = "block";
            setTimeout(function(){
                $this.geoModal.classList.add("on");
            },100);
        }
        return true;
    }

    initClose( $this, definitive ) {

        $this.geoModal.removeAttribute('data-active');

        // Definitive closing, dont check if still active (close button within modal)
        if (typeof definitive == "boolean") {
            return $this.close($this);
        }

        // Check for delay, in case mouse was entered back
        $this.closing = setTimeout(function(){

            if (!$this.geoModal.hasAttribute('data-active')) {
                $this.close($this);
            }
        }, 300);

        return true;

    }

    close($this) {

        $this.geoModal.classList.remove("on");
        $this.geoModal.classList.add("transitioning");
        setTimeout(function(){
            // Extra check to see if really left the building
            if (!$this.geoModal.hasAttribute('data-active')) {
                $this.geoModal.style.display = "none";
            }
        }, 250);
        $this.closing = null;

        return true;

    }

    initTriggers() {
        // Usage :
        // data-garage-select-id="{{ID}}"
        // data-garage-geolocalise

        this.eleSelectId = document.querySelectorAll('[data-garage-select-id]');
        this.eleGeolocalise = document.querySelectorAll('[data-garage-geolocalise]');

        this.eleSelectId.forEach((ele) => {
            const garageId = parseInt(ele.dataset.garageSelectId);
            ele.addEventListener("click", (e) => {
                e.preventDefault();
                this.selectGarageById(garageId);
                return false;
            });
        });

        this.eleGeolocalise.forEach((ele) => {
            ele.addEventListener("click", (e) => {
                if (!this.garage) {
                    e.preventDefault();
                    this.findNearest();
                    return false;
                }
            });
        });

        this.eleBtnGeolocateMe.forEach((ele) => {
            ele.addEventListener("click", (e) => {
                if (!this.coords && this.geoPermission == null) {
                    e.preventDefault();

                    // get coords and append to href
                    if (navigator.geolocation) {
                        navigator.geolocation.getCurrentPosition(
                            (position) => {
                                this.geoPermission = true;
                                this.coords = position.coords;
                                ele.href += '?location=' + this.coords.latitude + ',' + this.coords.longitude;
                                window.location.href = ele.href;
                            },
                            (error) => {
                                this.geoPermission = false;
                                window.location.href = ele.href;
                            }
                        );
                    }

                    return false;
                }else{
                    
                }
            });
        });
    }

    initNearest() {
        let garageId = this.getStorage();
        if (!garageId) {
            this.findNearest();
        } else {
            this.selectGarageById(garageId);
        }
    }

    selectGarageById(garageId) {
        this.fetchGarageById(garageId).then(
            (data) => {
                if (data.result && data.result.length) {
                    this.garage = data.result[0];
                    this.setStorage(this.garage.id);
                }else{
                    this.garage = null;
                    this.removeStorage();
                }
                this.resolveGarage();
            },
            (error) => {
                this.garage = null;
                this.resolveGarage();
            }
        );
    }

    findNearest() {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    this.geoPermission = true;
                    this.coords = position.coords;
                    this.fetchNearestByCoords(position.coords).then(
                        (data) => {
                            this.garage = data.result[0];
                            this.setStorage(this.garage.id);
                            this.resolveGarage();
                        },
                        (error) => {
                            this.resolveGarage();
                        }
                    );
                },
                (error) => {
                    this.geoPermission = false;
                    this.resolveGarage();
                }
            );
        }else{
            this.geoPermission = false;
            this.resolveGarage();
        }
    }

    getStorage() {
        return window.localStorage.getItem(this.storageKey);
    }

    setStorage(garageId) {
        window.localStorage.setItem(this.storageKey, garageId);
    }

    removeStorage(garageId) {
        window.localStorage.removeItem(this.storageKey);
    }

    fetchNearestByCoords(coords) {
        return new Promise((resolve, reject) => {
            fetch('/wp-json/napa/v1/garage/findnearest/'+coords.latitude+','+coords.longitude, this.fetchOptions).then(
                (response) => {
                    if (response.ok) {
                        resolve(response.json());
                    } else {
                        reject(response);
                    }
                },
                (error) => {
                    reject(error);
                }
            );
        });
    }

    fetchGarageById(garageId) {
        return new Promise((resolve, reject) => {
            fetch('/wp-json/napa/v1/garage/'+garageId, this.fetchOptions).then(
                (response) => {
                    if (response.ok) {
                        resolve(response.json());
                    } else {
                        reject(response);
                    }
                },
                (error) => {
                    reject(error);
                }
            );
        });
    }

    resolveGarage() {
        this.populateModal();
        this.updateNodes();
    }

    populateModal() {
        this.parent.classList[this.garage ? 'add' : 'remove']('active');
        this.geoCta.href = this.garage ? this.garage.url : this.defaultHref;

        if (!this.garage) return;

        this.geoCtaAddress.innerHTML = geoCtaTemplate(this.garage);

        this.geoModal.querySelector('.contact-tile__title').innerHTML = this.garage.name;
        this.geoModal.querySelector('.contact-tile__phone').innerHTML = geoModalPhoneTemplate(this.garage);
        this.geoModal.querySelector('address').innerHTML = geoModalAddressTemplate(this.garage);
        this.geoModal.querySelector('.contact-tile__directions').href = this.garage.directions;
        this.geoModal.querySelector('.contact-tile__openinghours').innerHTML = this.garage.opening_hours;
        this.geoModal.querySelector('.block__link .button').href = this.garage.url;
    }

    updateNodes() {
        // Usage :
        // data-garage-visible-id="{{ID}}" style="display: none;"
        // data-garage-visible style="display: none;"
        // data-garage-hidden-id="{{ID}}"
        // data-garage-hidden

        this.eleVisible = document.querySelectorAll('[data-garage-visible]');
        this.eleVisibleId = document.querySelectorAll('[data-garage-visible-id]');
        this.eleHidden = document.querySelectorAll('[data-garage-hidden]');
        this.eleHiddenId = document.querySelectorAll('[data-garage-hidden-id]');

        this.eleVisible.forEach((ele) => {
            this.toggleNodeDisplay(ele, this.garage)
        });
        this.eleVisibleId.forEach((ele) => {
            this.toggleNodeDisplay(ele, this.garage && parseInt(ele.dataset.garageVisibleId) == parseInt(this.garage.id))
        });
        this.eleHidden.forEach((ele) => {
            this.toggleNodeDisplay(ele, !this.garage)
        });
        this.eleHiddenId.forEach((ele) => {
            this.toggleNodeDisplay(ele, !(this.garage && parseInt(ele.dataset.garageHiddenId) == parseInt(this.garage.id)))
        });

        if (this.coords) {
            this.eleBtnGeolocateMe.forEach((ele) => {
                ele.href += '?location=' + this.coords.latitude + ',' + this.coords.longitude;
            });
        }

    }

    toggleNodeDisplay(ele, visibility) {
        if (visibility) {
            ele.style.removeProperty('display');
        }else{
            ele.style.setProperty('display', 'none');
        }
    }



}

export default Geo;






// WEBPACK FOOTER //
// ./scripts/components/geo.js